import { render } from "./ModulesComponent.vue?vue&type=template&id=ae491602&scoped=true"
import script from "./ModulesComponent.vue?vue&type=script&lang=js"
export * from "./ModulesComponent.vue?vue&type=script&lang=js"

import "./ModulesComponent.vue?vue&type=style&index=0&id=ae491602&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae491602"]])

export default __exports__